import React from 'react';
import { render } from 'react-dom';

import SimpleSitesApp from './SimpleSitesApp';

import { translationsReady } from '../localization/translate';
import { setup as setupMaps } from '../services/maps';

function renderApp() {
  render(
    (<SimpleSitesApp />),
    document.getElementById('app-container')
  );
}

function startApp() {
  setupMaps(['geometry']);

  renderApp();

  // Delay loading analytics till the app itself has loaded up.
  global.analytics.load();
}

translationsReady.subscribe(ready => {
  if (ready && window.igglo.polyfillsReady) {
    startApp();
  } else {
    window.igglo.runThisWhenPolyfillsAreReady = startApp;
  }
});
